import Vue from 'vue';
import './plugins/vuetify'
import './plugins/vue-progressbar'
import i18n from './plugins/vueI18n'
import './plugins/vue-currency-filter'
import './plugins/vue-moment'
import './plugins/vue-lodash'
import './plugins/vue-toasted'
import './plugins/sweetalert2'
import './plugins/vue-events'
import './plugins/vue-socket-io'
import './plugins/vue-google-oauth2'
import './plugins/vue-js-toggle-button'
import './Filter/USPhoneNumber'
import './Filter/Search'
import App from './App.vue';
import router from './router';
import store from './plugins/vuex'
import './registerServiceWorker';
// import $ from 'jquery'

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app');
